import MessageBroker from '@Services/MessageBroker';
import RequestUrls from '@Constants/RequestUrlsConstants';
import {
  FETCH_PROJECT_BREADCRUMB_INFO,
  FETCH_PROJECT_BREADCRUMB_INFO_FAILURE,
  FETCH_PROJECT_BREADCRUMB_INFO_SUCCESS,
  FETCH_PROJECTS_COUNT_SUCCESS,
} from '@Pages/RetroSynthesis/RsBreadcrumbs/constants';
import { noCache } from '@Utils/Network';

export const fetchProjectBreadcrumbInfoAction = (projectId) => async (dispatch) => {
  dispatch({ type: FETCH_PROJECT_BREADCRUMB_INFO, projectId });
  try {
    const result = await MessageBroker.send(RequestUrls.rsProjectInfo, { projectId }, { cache: false });
    if (!result) {
      // project not accessible
      dispatch({
        type: FETCH_PROJECT_BREADCRUMB_INFO_FAILURE,
        projectId,
      });
    } else {
      dispatch({
        type: FETCH_PROJECT_BREADCRUMB_INFO_SUCCESS,
        payload: result,
        projectId,
      });
    }
  } catch (e) {
    dispatch({
      type: FETCH_PROJECT_BREADCRUMB_INFO_FAILURE,
      payload: e,
      projectId,
    });
  }
};

export const fetchProjectsCountAction = () => async (dispatch) => {
  try {
    const response = await MessageBroker.send(RequestUrls.rsProjectsCount, {}, noCache());
    dispatch({ type: FETCH_PROJECTS_COUNT_SUCCESS, payload: response });
  } catch (error) {
    Logger.error('fetchProjectsCountAction - projects count fetching failed', error);
  }
};
